/**
 * The same as `Object.keys`, but with the return type not widened.
 *
 * WARNING: This assumes that there are no untyped properties in the object. If
 *          there are extra properties, they will not be included in the return
 *          type. https://github.com/Microsoft/TypeScript/issues/12936
 */
export function objectKeys(obj) {
  return Object.keys(obj);
}